import type { TopicFormValues } from './Topics.types.ts';

export const getTopicValues = (data: TopicFormValues) => ({
  id: data?.id || '',
  name: data?.name || '',
  order: data?.order || 1,
  type: data?.type || '',
  parentTopicId: data?.parentTopicId || '',
});

export const getTopicData = () => ({});